// AlertDialog.js
import React from "react";

const AlertDialog = ({ open, message, onClose }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional
      }}
    >
      <div
        // style={{
        //   background: "#fff",
        //   padding: "24px 32px",
        //   borderRadius: "8px",
        //   minWidth: "300px",
        //   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        //   textAlign: "center",
        // }}
        style={{
          position: "fixed",
          top: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          background: "#fff",
          padding: "16px 24px",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          zIndex: 1000,
          minWidth: "320px",
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: "16px", fontSize: "16px", color: "#333" }}>
          {message}
        </div>
        <button
          onClick={onClose}
          style={{
            padding: "8px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default AlertDialog;
